<template>
  <Breadcrumbs
      title="Add Document Template"
      :breadcrumbs="[
      { label: 'System Config', path: '' },
      { label: 'Add Document Template', path: '/add-document-template' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <addDocumentTemplateForm/>
    </div>
  </div>
</template>

<script>

import addDocumentTemplateForm from "@/pages/system_config/document_templates/addDocumentTemplateForm.vue";

export default {
  components: {
    addDocumentTemplateForm
  }
}

</script>